import { TradingPanel, TradingText } from '@trading-ui/core';
import { useTranslation } from 'react-i18next';

import * as styles from './NoCompanySelectedPanel.css';

export default function NoCompanySelectedPanel() {
  const { t } = useTranslation();

  return (
    <TradingPanel className={styles.root}>
      <TradingText text={t('settings.companyDetailsTab.noCompanySelectedMessage')} />
    </TradingPanel>
  );
}
